<template>
	<div full-height>

		<v-toolbar flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Set Daily Timer</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar grey-back" style="height:calc(100% - 48px);">

            <v-alert type="info" icon="timer" :value="true">
                Set timer to turn on mobile server
            </v-alert>
	    	
	    	<v-list two-line grey-back nopadding>
	    		
	    		<v-list-tile class="ma-3 white-background" style="border-radius: 5px;" @click="fn_openTimePicker">

                    <v-list-tile-content>
                        <v-list-tile-title>ON Timer</v-list-tile-title>
                        <!-- <v-list-tile-sub-title>{{ formattedTime ? formattedTime : 'HH:MM' }} <v-icon font20>arrow_drop_down</v-icon></v-list-tile-sub-title> -->
                    </v-list-tile-content>

                    <v-list-tile-action style="min-width: auto;flex-direction:row;justify-content:end;">
                        <v-chip color="primary" class="pr-1 whitecolor" small>{{ formattedTime ? formattedTime : '_ _ : _ _' }} <v-icon class="whitecolor font20">arrow_drop_down</v-icon></v-chip>
                    </v-list-tile-action>

                </v-list-tile>

                <v-list-tile class="ma-3 white-background" style="border-radius: 5px;">

                    <v-list-tile-content>
                        <v-list-tile-title>Turn off after</v-list-tile-title>
                        <!-- <v-list-tile-sub-title>{{ formattedTime ? formattedTime : 'HH:MM' }} <v-icon font20>arrow_drop_down</v-icon></v-list-tile-sub-title> -->
                    </v-list-tile-content>

                    <v-menu style="border-radius: 5px;">
                        <v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
                            <v-chip color="primary" class="pr-1 whitecolor" small>{{ duration }} {{ duration > 1 ? 'hours' : 'hour' }} <v-icon class="whitecolor font20">arrow_drop_down</v-icon></v-chip>
                        </v-list-tile-action>

                        <v-list nopadding dense>
                            <v-list-tile @click="duration=1">
                                <v-list-tile-content>
                                    <v-list-tile-title>1 hour</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile @click="duration=4">
                                <v-list-tile-content>
                                    <v-list-tile-title>4 hours</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile @click="duration=8">
                                <v-list-tile-content>
                                    <v-list-tile-title>8 hours</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    </v-list-tile>

                    <v-alert color="info" :value="true" class="ma-3 pa-3 mt-5">
                        <p class="mb-2 font-medium">Notes:</p>
                        <ul>
                            <li class="mb-2">Mobile server is necessary for <strong>desktop connection</strong>.</li>
                            <li>Mobile server will turn on daily at the time you set here and will turn off after selected hours.</li>
                        </ul>
                    </v-alert>

	    	</v-list>

            <input type="time" id="time_picker" style="visibility: hidden;" v-model="serverOnTime">

            <!-- {{ serverOnTime | moment("h:mm A") }} -->

	    	<!-- <div v-if="!filteredItems.length" class="display_msg">There are no connection requests!</div> -->
	    </div>

        <v-layout row wrap>
            <v-flex xs6 sm6 md6 v-if="hasData">
                <v-btn style="height: 48px;" block no-round-borders noshadow flat color="red" class="ma-0" @click="fn_removeAlarmData">Remove</v-btn>
            </v-flex>
            <v-flex :class="[hasData ? 'xs6 sm6 md6' : 'xs12 sm12 md12']">
                <v-btn style="height: 48px;" block no-round-borders noshadow color="primary" class="ma-0" @click="fn_updateTime">Save</v-btn>
            </v-flex>
        </v-layout>

	</div>
</template>

<script>


	export default{
		data(){
			return{
                // pickerVal:null,
                serverOnTime:null,
                duration:8,
                hasData:false
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

            fn_openTimePicker: function(){
                document.getElementById('time_picker').click();
            },

            fn_updateTime: function(){
                if(!this.serverOnTime){
                    this.showToast('Set On Timer');
                    return;
                }

                // this.serverOnTime = this.pickerVal;

                let val = this.serverOnTime;
                // console.log(val);
                let hour = val.substring(0, val.indexOf(':'));
                let minute = val.substring(val.indexOf(':') + 1);
                let serviceStartTime = new Date().setHours(hour, minute, 0, 0);
                let serviceEndHours = new Date(serviceStartTime).getHours() + this.duration;
                let serviceEndMinutes = new Date(serviceStartTime).getMinutes();
                let serviceEndTime = new Date(serviceStartTime).setHours(serviceEndHours,serviceEndMinutes,0,0);
                console.log(serviceStartTime);

                this.showLoading("Please wait...");

                this.$root.fn_getAuthToken(token=>{

                    let postObj = {
                        "BusinessID":this.$root.CurrentBusiness.BusinessID, 
                        "alarmTime":serviceStartTime,
                        "alarmInterval":24*60*60*1000,
                        "alarmCloseTime":serviceEndTime,
                        "alarmDuration":this.duration,
                        "token":token
                    };

                    let self = this;
                    this.postServerData('SetAlarmForService', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            self.showToast("Timer set");
                            self.fn_goBack();
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            console.log(error);
                        }
                    });
                })
            },

            fn_getAlarmData: function(){
                let self = this;
                this.getData('GetAlarmData', null, 
                    {
                    onSuccess: function(response){
                        console.log(response);
                        let data = JSON.parse(response);
                        if(data && Object.keys(data).length){
                            let alarmTime = new Date(data.alarmTime).toTimeString();
                            self.serverOnTime = alarmTime.substring(0, alarmTime.lastIndexOf(":"));
                            // self.serverOnTime = self.pickerVal;
                            self.duration = data.duration;
                            self.hasData = true;
                        }
                    }, 
                    onError: function(error){
                        self.showToast('Something went wrong. Please try again.');
                    }
                });
            },

            fn_removeAlarmData: function(){
                let self = this;

                this.showLoading("Please wait...");

                this.$root.fn_getAuthToken(token=>{
                    let postObj = {
                        "BusinessID":this.$root.CurrentBusiness.BusinessID,
                        "token":token
                    }

                    this.postServerData('CancelAlarm', postObj, {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            self.showToast("Timer removed");
                            self.fn_goBack();
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            console.log(error);
                            self.showToast('Something went wrong. Please try again.');
                        }
                    });
                })
            }

			
		},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
            this.fn_getAlarmData();
	  	},
        computed:{
            formattedTime: function(){
                if(this.serverOnTime){
                    return this.$moment(this.serverOnTime, ["HH.mm"]).format("hh:mm A");    
                }
                else{
                    return null;
                }
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/connection_requests/service_timer.vue